// In February of 2020, the Design Systems team renamed and consolidated some icons in an effort to introduce consistency in the naming of our icons. This object maps old, deprecated icon names to the "correct" name of the icon {"deprecated key": "correct icon name value"}
export default {
  backtotop: 'back-to-top',
  'circle-check-filled': 'circle-check',
  'circle-check-no-fill': 'circle-check',
  'circle-check-inverse-outline': 'circle-check-outline',
  'circle-check-inverse': 'circle-check-outline',
  'circle+-filled': 'circle+',
  'circlex-filled': 'circlex',
  'circle+-nofill': 'circle+',
  'circlex-nofill': 'circlex',
  creditcard: 'credit-card',
  'direct-message': 'messages',
  'facebook-nofill': 'facebook',
  googleanalytics: 'google-analytics-color',
  'instagram-brand-keyword': 'hashtag',
  'help-white': 'help',
  'info-white': 'info',
  'instagram-nofill': 'instagram',
  'key-circle': 'key',
  'key-square': 'key',
  'linkedin-nofill': 'linkedin',
  'listening-home': 'listening',
  'location-pub': 'location',
  'location-pub-outline': 'location-outline',
  'publishing-calendar': 'calendar',
  qrcode: 'qr-code',
  'sparkles-solid': 'sparkles',
  'star-inverse': 'star-outline',
  'triangle-white': 'triangle',
  'triangle-nofill': 'triangle',
  'tripadvisor-circle-filled': 'tripadvisor-circle',
  'tripadvisor-circle-empty': 'tripadvisor-circle-outline',
  'tumblr-square': 'tumblr',
  'tumblr-nofill': 'tumblr',
  'twitter-business-mention': 'search',
  'verified-nofill': 'verified',
  'window-maximize-solid': 'window-maximize'
};